<template>
  <div>
    <el-container class="pageBox">
      <el-header class="headerBox">
        <logo />
        <top-nav v-if="$globalVariable.menuDirection == 'top'" />
        <!-- <user-box class="userBox" /> -->
      </el-header>
      <el-container class="root">
        <el-container>
          <el-main class="pageHome">
            <el-container>
              <el-aside
                class="sideBar"
                v-if="$globalVariable.menuDirection == 'right'"
              >
                <right-nav></right-nav>
              </el-aside>
              <el-main class="pageMain">
                <Title v-show="routeData.indexOf($route.name) === -1" />
                <keep-alive>
                  <router-view :key="key" v-if="$route.meta.noCache" />
                </keep-alive>
                <router-view :key="key" v-if="!$route.meta.noCache" />
              </el-main>
            </el-container>
            <el-footer>
              <footer-Box></footer-Box>
            </el-footer>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "Layout",
  props: {
    //传值
  },
  data() {
    return {
      routeData: ["Home"],
    };
  },
  components: {
    //引入模块
    topNav: () => import("@/components/Navbar/topNav"),
    // rightNav: () => import("@/components/Navbar/rightNav"),
    logo: () => import("@/components/logo/index"),
    Title: () => import("@/components/title/index"),
    // userBox: () => import("@/components/userBox/index"),
    footerBox: () => import("@/components/footerBox/index"),
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
    key() {
      return this.$route.path;
    },
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
  },
  activated: function () {
    // 狗子触发顺序最后时执行，当再次进入（前进或者后退）时，只触发activated
  },
  methods: {
    // 组件的方法
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  },
  destroyed: function () {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>
<style lang="scss" scoped>
.pageBox {
  ::v-deep .el-footer {
    height: fit-content !important;
  }
  .headerBox {
    position: fixed;
    z-index: 1000;
    width: 100%;
    background-image: linear-gradient(
      to right,
      #1b9c94,
      #0f9c8b,
      #0d9b80,
      #179a75,
      #249968,
      #3c9f64,
      #50a561,
      #63ab5d,
      #82b963,
      #a0c76b,
      #bed574,
      #dce37f
    );
    padding-left: $TopPadding;
    padding-right: $TopPadding;
    height: auto !important;
    // div {
    //   float: left;
    //   height: 100%;
    //   min-width: 5%;
    // }
    // div:nth-child(2) {
    //   min-width: 95%;
    // }
    .userBox {
      position: absolute;
      right: $TopPadding;
    }
  }
  .el-main {
    padding: 10px !important;
  }
  .pageMain {
    overflow: hidden;
  }
  .root {
    // min-height: calc(100vh - 200px);
    // overflow: auto;
    margin-top: 200px;
    .sideBar {
      width: $sideBarWidth !important;
    }
  }
}
</style>